import React, { useState } from 'react';

const Form = ({
  buttonText,
  placeholder,
  modifierClass,
  formName
}) => {
  const [email, setEmail] = useState('');

  const handleEmailChange = e => {
    setEmail(e.target.value);
  };

  const encode = data => {
    return Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
  };

  const handleSubmit = e => {
    e.preventDefault();
    const formMessageSuccess = e.currentTarget.querySelector('.form__message--success');
    const formMessageError = e.currentTarget.querySelector('.form__message--error');
    const email = e.currentTarget.querySelector('[name="email"]').value;

    if (formMessageSuccess && email && formName) {
      fetch('/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: encode({
          'form-name': formName,
          email: email
        })
      }).then(result => {
        if (result.ok) {
          formMessageSuccess.classList.add('form__message--show');
          setTimeout(() => {
            formMessageSuccess.classList.remove('form__message--show');
          }, 8000);
        } else {
          formMessageError.classList.add('form__message--show');
          setTimeout(() => {
            formMessageError.classList.remove('form__message--show');
          }, 4000);
        }
      }).catch(() => {
        formMessageError.classList.add('form__message--show');
        setTimeout(() => {
          formMessageError.classList.remove('form__message--show');
        }, 4000);
      });
    } else {
      formMessageError.classList.add('form__message--show');
      setTimeout(() => {
        formMessageError.classList.remove('form__message--show');
      }, 4000);
    }
  };

  return /*#__PURE__*/React.createElement("form", {
    name: formName,
    onSubmit: handleSubmit,
    "data-netlify": "true",
    "data-netlify-honeypot": "bot-field"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "form-name",
    value: formName
  }), /*#__PURE__*/React.createElement("div", {
    className: "form__input input__text--icon icon--email"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "footer-email-input",
    className: "visually-hidden"
  }, "Email"), /*#__PURE__*/React.createElement("div", {
    className: "input__group ".concat(modifierClass)
  }, /*#__PURE__*/React.createElement("input", {
    value: email,
    onChange: handleEmailChange,
    type: "email",
    name: "email",
    placeholder: placeholder,
    className: "input",
    id: "footer-email-input"
  }), /*#__PURE__*/React.createElement("input", {
    type: "submit",
    className: "button",
    value: buttonText
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form__message form__message--success"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": "Tada"
  }, "\uD83C\uDF89"), ' ', "Awesome!"), /*#__PURE__*/React.createElement("p", null, "Please check your inbox for a confirmation email. It might take a minute or so.")), /*#__PURE__*/React.createElement("div", {
    className: "form__message form__message--error"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": "Hmmm"
  }, "\uD83E\uDD14"), ' ', "Whoops!"), /*#__PURE__*/React.createElement("p", null, "Something went wrong. Check that you have entered a valid email and try submitting the form again.")));
};

Form.displayName = 'Form';
Form.defaultProps = {
  buttonText: 'Request a Demo',
  placeholder: 'Enter your work email...',
  modifierClass: '',
  formName: 'contact'
};
export default Form;